import { Button, ButtonGroup, Flex, IconButton } from '@chakra-ui/react';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link as RouteLink, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

interface QuestionDetailsHeaderButtonsProps {
  nextQuestionNo: number | null;
  previousQuestionNo: number | null;
}
function QuestionDetailsHeaderButtons(props: QuestionDetailsHeaderButtonsProps) {
    const { t } = useTranslation('common');
  const navigate = useNavigate();

  const toPreviousQuestion = () => {
    navigate(`../questions/${props.previousQuestionNo ?? ''}`);
  };
  const toNextQuestion = () => {
    navigate(`../questions/${props.nextQuestionNo ?? ''}`);
  };

  const hasNextQuestion = props.nextQuestionNo !== null;
  const hasPreviousQuestion = props.previousQuestionNo !== null;

  return (
    <Flex mb="3">
      <Button
        as={RouteLink}
        to={'..'}
        variant="ghost"
        ml="-3.5"
        leftIcon={<FontAwesomeIcon className="utility-icon" icon={regular('arrow-left')} />}
      >
        {t('common:allQuestions')}
                    </Button>

      <ButtonGroup ml="auto" isAttached>
        <IconButton
          aria-label={t('common:previousQuestion')}
          variant="ghost"
          isDisabled={!hasPreviousQuestion}
          onClick={toPreviousQuestion}
          icon={<FontAwesomeIcon icon={regular('chevron-left')} />}
        />

        <IconButton
          aria-label={t('common:nextQuestion')}
          variant="ghost"
          isDisabled={!hasNextQuestion}
          onClick={toNextQuestion}
          icon={<FontAwesomeIcon icon={regular('chevron-right')} />}
        />
      </ButtonGroup>
    </Flex>
  );
}

export default QuestionDetailsHeaderButtons;
